import termsStrings from "rivals/shared/strings/terms";

export default {
  ...termsStrings,
  requiredSubscriptionAgreement: "SUBSCRIPTION AGREEMENT - Required"
};
